import React from 'react';
import ReactDOM from 'react-dom/client';
import "font-awesome/css/font-awesome.min.css";
import App from './app'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

         <App />

   );

